import { Injector, Signal, inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { CurrentOrganizationUsersFilter } from '@mp/kernel/current-organization-users/domain';

import { CurrentOrganizationUsersService } from '../services';

export function injectCurrentOrganizationUsersQuery(
  filter: Signal<CurrentOrganizationUsersFilter>,
  injector: Injector = inject(Injector),
) {
  const currentOrganizationUsersService = injector.get(CurrentOrganizationUsersService);

  return injectQuery(
    () => ({
      queryKey: ['current-organization', 'users', filter()],
      staleTime: 60_000,
      queryFn: () => lastValueFrom(currentOrganizationUsersService.fetchUsers(filter())),
      refetchOnWindowFocus: false,
    }),
    injector,
  );
}
